import OnlineStatusBanner from "@/components/OnlineStatusBanner";
import type { AuthContextType } from "@/contexts/AuthContext";
import { createRootRouteWithContext, HeadContent, Outlet, redirect } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import { Toaster } from "sonner";

interface AuthRouterContext {
  // The ReturnType of your useAuth hook or the value of your AuthContext
  auth: AuthContextType;
}

export const Route = createRootRouteWithContext<AuthRouterContext>()({
  beforeLoad: (ctx) => {
    if(ctx.location.pathname.includes("dashboard/manager")){
      throw redirect({to: "/"});
    }
  },
  component: () => (
    <>
      <OnlineStatusBanner />
      <HeadContent />
      <NuqsAdapter>
        <Outlet />
      </NuqsAdapter>
      <Toaster position="top-right" richColors />
      <TanStackRouterDevtools position="bottom-right" />
    </>
  ),
});
